export default __webpack_public_path__ + "static/media/TKM.7ef24772.svg";